import React from "react";
import "./overlay.css";

const Overlay = () => {
  const off = () => {
    document.getElementById("overlay").style.display = "none";
  };

  return (
    <div id="overlay" onClick={off}>
      <img id="overlay-img" src="" alt="not" />
    </div>
  );
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/helpers/Overlay.jsx